var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== null)?_c('span',{staticClass:"pass-rate",class:_vm.baselineColumn && _vm.baselineColumn.baseline != null
      ? `color-${_vm.baselineResult(_vm.value, _vm.baselineColumn.baseline, _vm.baselineColumn.improvement)}`
      : '',style:(_vm.style)},[_vm._v(" "+_vm._s((_vm.value * 100).toFixed(2))+"% ")]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }